var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.00067 8C6.218 8 6.422 7.894 6.54667 7.71533L11.2133 1.04867C11.356 0.845333 11.372 0.579333 11.2587 0.358667C11.1433 0.138 10.916 0 10.6673 0H1.33267C1.084 0 0.85667 0.138 0.741336 0.358667C0.628003 0.579333 0.644003 0.845333 0.78667 1.04867L5.45334 7.71533C5.578 7.894 5.782 8 5.99934 8H6.00067Z",
    fill: "#3DA64F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.f61328109a150a55cdfc938aa1407a62.svg";
export { ForwardRef as ReactComponent };